/**
 * Mass Transfer
 */
$(document).on("ready", function () {
    $(document).on("click", "#my-plans", function (e) {
    e.preventDefault();
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      data:{action:'fw_my_masstransfer_plans_ajax'},
      success: function (data) {
        addOverlay("my-colleges", data);
        $("#overlay .add span").off("click");
        addOverlay("my-colleges", data);
        $("#overlay .add span").off("click");
        $("#overlay").on("click", ".add span", function () {
          var $add = $(this);
          if ($add.hasClass("remove")) {
            $add.text("Add").removeClass("remove");
            $add.toggleClass("primary secondary");
            $(".selected").each(function () {
              if ($(this).attr("data-id") === $add.attr("id")) {
                var $tr = $add.closest("tr");
                $(this).attr("data-id", "");
                $(this).html('<td class="college">&nbsp;</td><td class="remove"></td>');
                // $('#overlay').remove();
                return false;
              }
            });
          } else {
            var count = $(".selected").length;
            var exists = false;
            $(".selected").each(function () {
              if ($(this).attr("data-id") === $add.attr("data-id")) {
                exists = true;
              }
            });
            if (exists) {
              alert("This school is already selected.");
              return false;
            }
            $(".selected").each(function () {
              if ($(this).attr("data-id") === "") {
                var $tr = $add.closest("tr");
                $(this).attr("data-id", "plan" + $add.attr("id"));
                $(this).html('<td class="college"><input type="hidden" name="PlanID[]" value="' + $add.attr("id") + '" />' + $tr.children(".name").text() + '</td><td class="remove">X</td>');
                // $('#overlay').remove();
                $add.text("Remove").addClass("remove");
                $add.toggleClass("primary secondary");
                return false;
              }
              if (!--count) {
                alert("You cannot add more than 5 colleges.  Please remove a school.");
              }
            });
          }
        });
      },
      error: function () {},
    });
  });
});
